
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ofte-stilte-sporsmal",
      function () {
        return require("private-next-pages/ofte-stilte-sporsmal.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ofte-stilte-sporsmal"])
      });
    }
  